// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__FhBXh","buttons":"RemoveExpirationActionButtons_buttons__2Y4lN"};